import React, { useState, useLayoutEffect } from 'react'; 
import { Row, Col, Card, Typography, Tooltip } from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlay, faShareAlt, faInfoCircle, faClock } from '@fortawesome/free-solid-svg-icons'
import { COLORS } from '../utils/Constants';

const { Text } = Typography;
const boxWidth = 160, boxWidth2 = 200;
const textFont = '12px';
const lineHeight = '1em';
let cardWidth = (window.innerWidth - 232)*5/6;
let boxHeight = cardWidth/3;

function renderInfo(textFont, lineHeight, title, name) {
    return <div>
        <p style={{ fontSize: textFont, color: '#7a8a9a', lineHeight: lineHeight, fontFamily: 'OpenSans-Bold', marginBottom: 4 }}>
            {title} <Text style={{ margin:0, fontSize: textFont, color: '#7a8a9a', fontFamily: 'OpenSans-Regular' }}>{name}</Text>
        </p>
    </div>
}

function useWindowSize() {
    const [size, setSize] = useState([0, 0]);
    useLayoutEffect(() => {
      function updateSize() {
        cardWidth = (window.innerWidth - 232)*5/6;
        boxHeight = cardWidth/3;        
        setSize([window.innerWidth, window.innerHeight]);
      }
      window.addEventListener('resize', updateSize);
      updateSize();
      return () => window.removeEventListener('resize', updateSize);
    }, []);
    return size;
  }

const TileWeb = React.memo(props => {
    
    // console.log('tileweb rendered='+props);
    const [width, height] = useWindowSize();
    const [mouseOver, setMouseOver] = useState(false);
    const [showMoreIndex, setShowMoreIndex] = useState(-1);
    let displayMovieObj = props.displayMovieObj;
    let index = props.index;      
    let uploadId = props.uploadId;  
    let windowUrl = window.location.href;
    if(windowUrl.includes('/movie/')&&(showMoreIndex!==index)) {
        setShowMoreIndex(index);
    }

    return (
        <Row style={{ marginBottom: 30 }}>
            <Col span={20} offset={2} style={{  }}>
                <Card className="customCard"
                    style={{ width: '100%', margin: 0, padding: 0, backgroundColor: COLORS.blue2a3a4a }}
                >
                    <div>
                        <div onClick={() => { props.buyButton(index, props.movieObj, props.showPrice) }} 
                        onMouseEnter={() => { setMouseOver(true) }} onMouseLeave={() => { setMouseOver(false) }}
                        style={{ cursor: 'pointer', flexDirection: 'column', position:'absolute', width:'100%', height: boxHeight, 
                        display:'flex', justifyContent: 'center', alignItems: 'center' }}>
                            <div style={{ width:'100%', height:'100%', display:'flex', justifyContent: 'center', alignItems: 'center', 
                            transition: 'background-color 100ms linear', backgroundColor: mouseOver ? 'rgba(26,42,58, 0.3)' : null }}>
                                <FontAwesomeIcon className='playButton' icon={faPlay} style={{ position:'absolute', opacity: 0.7, color: COLORS.eeeWhite, fontSize: 60 }} 
                                />
                                <div style={{ marginTop: 100 }}>
                                    <p className='watchTrailer' style={{ fontFamily: 'OpenSans-Bold', opacity: 0.7, color: COLORS.eeeWhite }}>{ mouseOver ? props.trailerText : '' }</p>
                                </div>
                            </div>
                        </div>
                        <img src={displayMovieObj.bannerImage} alt={displayMovieObj.movieName} style={{ height: boxHeight, width: '100%' }} />
                        <Row style={{ backgroundColor: COLORS.blue2a3a4a }}>
                            <Col flex='1' style={{ padding: '20px', paddingBottom: 0 }}>
                                <p style={{ maxWidth: cardWidth-600, overflow: 'hidden', textOverflow: 'ellipsis', fontSize: '17px', fontFamily: 'OpenSans-Bold', color: COLORS.yellow, lineHeight: 1, marginTop: 8, marginBottom: 0, paddingBottom: 4 }}>
                                    {displayMovieObj.movieName} 
                                </p>
                                <p style={{ whiteSpace: 'break-spaces', fontSize: textFont, color: COLORS.lightBlue, lineHeight: 1.4, fontFamily: 'OpenSans-Bold' }}>
                                    {'Release: '+props.releaseDateTimeString+' Hrs\n'}{props.expiryString}
                                </p>
                            </Col>
                            <Col style={{ display:'flex', justifyContent:'center', marginTop: 28 }} flex={boxWidth2+'px'}>
                                <div style={{ display: 'flex', flexDirection: 'column' }}>
                                    <div style={{ display: 'flex', flexDirection: 'row' }}>
                                        <div style={{ width: 48 }}>
                                            <Tooltip className='tileTip' title={"Suitable for ages "+displayMovieObj.rating}>
                                            <img src={props.ratingImage} alt={displayMovieObj.rating} style={{ width: 32, height: 32, margin: 8 }} />
                                            </Tooltip>
                                        </div>
                                        <div style={{ width: 48, display: 'flex', flexDirection: 'column' }}>
                                            <Tooltip className='tileTip' title={"Duration: "+displayMovieObj.duration}>
                                                <FontAwesomeIcon color={COLORS.lightBlue} icon={faClock} 
                                                style={{ cursor: 'pointer', fontSize: 24, margin: '12px', marginBottom: 0 }} />
                                            </Tooltip>
                                            <div>
                                                <p style={{ whiteSpace: 'pre', width: 48, position: 'absolute', fontSize: 12, fontFamily: 'OpenSans-Bold', color: COLORS.lightBlue, textAlign: 'center', marginTop: 0, lineHeight: 2 }}>
                                                    {displayMovieObj.duration}
                                                </p>
                                            </div>
                                        </div>
                                        <div style={{ width: 48, display: 'flex', flexDirection: 'column' }}>
                                            <Tooltip className='tileTip' title={"Show More"}>
                                                <FontAwesomeIcon onClick={() => { setShowMoreIndex(showMoreIndex===index ? -1 : index) }} color={COLORS.lightBlue} 
                                                icon={faInfoCircle} style={{ cursor: 'pointer', fontSize: 24, marginTop: 12, marginLeft: 12, marginRight: 0 }} />
                                            </Tooltip>
                                        </div>
                                        <Tooltip className='tileTip' title={"Share"}>
                                        <FontAwesomeIcon onClick={() => { props.shareUrl(displayMovieObj.sharedUrl, index) }} color={COLORS.lightBlue} icon={faShareAlt} 
                                        style={{ cursor: 'pointer', fontSize: 24, marginLeft: 15, margin: '12px' }} />
                                        </Tooltip>
                                    </div>
                                    <div style={{ position: 'absolute', width: boxWidth2, top: -20, right: 0, display: 'flex', justifyContent: 'center' }}>
                                        <p style={{ fontSize: 12, fontFamily: 'OpenSans-Bold', color: COLORS.yellow }}>
                                            {props.linkText}
                                        </p>
                                    </div>
                                </div>
                            </Col>
                            <Col style={{ margin: '20px', marginLeft: 0 }} flex={boxWidth+'px'}>
                                <div onClick={() => { props.buyButton(index, props.movieObj, props.showPrice) }}>
                                { props.button }
                                </div>
                            </Col>
                            { showMoreIndex===index
                            ?
                            <div style={{ marginBottom: 8, marginLeft: 20, width: cardWidth-60 }}>
                                {renderInfo('13px', 1.5, '', displayMovieObj.summary)}
                                {renderInfo(textFont, lineHeight, 'Language: ', displayMovieObj.language)}
                                {renderInfo(textFont, lineHeight, 'Genre: ', displayMovieObj.genre)}
                                {renderInfo(textFont, lineHeight, 'Director: ', displayMovieObj.directors)}
                                {renderInfo(textFont, lineHeight, 'Producer: ', displayMovieObj.producers)}
                                {renderInfo(textFont, lineHeight, 'Writers: ', displayMovieObj.writers)}
                                {renderInfo(textFont, lineHeight, 'Stars: ', displayMovieObj.stars)}
                                {renderInfo(textFont, lineHeight, 'Production House: ', displayMovieObj.productionHouse)}
                            </div>
                            :
                            <div/>
                            }
                        </Row>                        
                    </div>
                </Card>
            </Col>
        </Row>
    );
});

export default TileWeb;